<template>
  <highcharts :constructor-type="'stockChart'" ref="chart" :options="options" />
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'GHGIsTimelines',
  props: {
    ghgis: {
      type: Array,
      default: null
    }
  },
  computed: {
    series: function () {
      let series = []
      let years = this.ghgis.map((ghgi) => ghgi.year)
      for (let year of Array.from(new Set(years))) {
        let cserie = {
          name: year,
          data: []
        }
        let timestamps = this.ghgis
          .filter((ghgi) => ghgi.year === year)
          .map((ghgi) => Date.parse(ghgi.created))
        let counts = {}
        for (let timestamp of timestamps) {
          counts[timestamp] = 1 + (counts[timestamp] || 0)
        }
        let cum = 0
        for (let timestamp of Object.keys(counts).sort()) {
          cserie.data.push([parseInt(timestamp), cum + counts[timestamp]])
          cum += counts[timestamp]
        }
        series.push(cserie)
      }
      return series
    },
    options: function () {
      return {
        series: this.series,
        rangeSelector: {
          selected: 4
        },
        tooltip: {
          shared: true,
          valueSuffix: ' ' + this.$t('compGraphicsGHGIsTimelines.ghgis')
        }
      }
    }
  }
}
</script>
